<template>
  <div class="d-flex justify-content-center flex-row align-items-center gap-2 view-switcher">
    <a v-for="o in options"
       @click="selectOption(o)"
       :class="{ active: value === o.id }"
       :key="`opt-${o.id}`">
      {{ $t(o.title) }}
    </a>
  </div>
</template>

<script setup>
defineProps({
  value: {},
  options: {}
})

const emit = defineEmits(['input'])

const selectOption = (option) => {
  emit('input', option.id)
}
</script>

<style scoped lang="scss">
.view-switcher {
  a {
    cursor: pointer;
    color: $gray-text2;
    height: 32px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    border-radius: 8px;
    font-weight: normal;
    font-size: 16px;
    &.active {
      color: $blue-color;
      background-color: $body-bg;
    }
  }
}
@media screen and (max-width: 768px) {
  .view-switcher {
    a {
      font-size: 12px;
      height: 26px;
    }
  }
}
</style>
